/** One stroke icon set, 24-grid, drawn inline so it scales and recolours (docs/03). */
const P: Record<string, string> = {
  home: "M3 10.6 12 3l9 7.6M5.6 9.6V21h12.8V9.6",
  studio: "M3 3h18v18H3zM3 9h18M9 21V9",
  shop: "M3 9h18l-1.5-5h-15L3 9zM3 9v10a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1V9M9 20v-6h6v6",
  content: "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4M17 8l-5-5-5 5M12 3v12",
  calendar: "M3 4h18v18H3zM16 2v4M8 2v4M3 10h18",
  analytics: "M18 20V10M12 20V4M6 20v-6",
  // SEO: a page with a magnifying glass over it — words somebody is looking for.
  seo: "M14 3H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h8M8 8h6M8 12h4M17 12a4 4 0 1 0 0 8 4 4 0 0 0 0-8zM22 22l-2.1-2.1",
  plus: "M12 5v14M5 12h14",
  search: "M11 3a8 8 0 1 0 0 16 8 8 0 0 0 0-16zM21 21l-4.35-4.35",
  chat: "M21 11.5a8.5 8.5 0 0 1-8.5 8.5 8.4 8.4 0 0 1-3.8-.9L3 21l1.9-5.7A8.5 8.5 0 1 1 21 11.5z",
  send: "M22 2 11 13M22 2l-7 20-4-9-9-4 20-7z",
  mic: "M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3zM19 10v2a7 7 0 0 1-14 0v-2M12 19v4",
  trash: "M3 6h18M8 6V4h8v2M19 6l-1 14H6L5 6M10 11v6M14 11v6",
  pencil: "M12 20h9M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4 12.5-12.5z",
  image: "M3 3h18v18H3zM21 15l-5-5L5 21",
  music: "M9 18V5l12-2v13M6 21a3 3 0 1 0 0-6 3 3 0 0 0 0 6zM18 19a3 3 0 1 0 0-6 3 3 0 0 0 0 6z",
  type: "M4 7V4h16v3M9 20h6M12 4v16",
  play: "M6 3l14 9-14 9V3z",
  stop: "M6 6h12v12H6z",
  pin: "M9 4h6l-1 6 4 3v2H6v-2l4-3-1-6zM12 15v5",
  // A market is a country, and Customers is the first thing here that draws one.
  globe: "M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18zM3.6 9h16.8M3.6 15h16.8M12 3a14 14 0 0 1 0 18M12 3a14 14 0 0 0 0 18",
  person: "M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2M12 3a4 4 0 1 0 0 8 4 4 0 0 0 0-8z",
  list: "M8 6h13M8 12h13M8 18h13M3 6h.01M3 12h.01M3 18h.01",
  pause: "M9 4v16M15 4v16",
  // The editor's transport (2026-09-25): sound on and off, back to the start, full screen.
  volume: "M11 5 6 9H3v6h3l5 4V5zM15.5 8.5a5 5 0 0 1 0 7M18.5 5.5a9 9 0 0 1 0 13",
  mute: "M11 5 6 9H3v6h3l5 4V5zM22 9l-6 6M16 9l6 6",
  toStart: "M6 5v14M18 5 9 12l9 7V5z",
  expand: "M4 9V4h5M20 9V4h-5M4 15v5h5M20 15v5h-5",
  shrink: "M9 4v5H4M15 4v5h5M9 20v-5H4M15 20v-5h5",
  zoomIn: "M11 3a8 8 0 1 0 0 16 8 8 0 0 0 0-16zM21 21l-4.35-4.35M11 8v6M8 11h6",
  zoomOut: "M11 3a8 8 0 1 0 0 16 8 8 0 0 0 0-16zM21 21l-4.35-4.35M8 11h6",
  x: "M18 6 6 18M6 6l12 12",
  check: "M20 6 9 17l-5-5",
  refresh: "M23 4v6h-6M20.49 15a9 9 0 1 1-2.12-9.36L23 10",
  download: "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4M7 10l5 5 5-5M12 15V3",
  upload: "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4M17 8l-5-5-5 5M12 3v12",
  // What Joogoos said on your reports (ADR 0024, amended 2026-10-05), beside the credit.
  bell: "M18 8a6 6 0 0 0-12 0c0 7-3 9-3 9h18s-3-2-3-9M13.7 21a2 2 0 0 1-3.4 0",
  coin: "M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18zM14.5 9.5a2.5 2.5 0 0 0-5 0c0 2.5 5 2.5 5 5a2.5 2.5 0 0 1-5 0M12 6v2M12 16v2",
  /** Customers (23): the tab, and the people a business is looking for. */
  users: "M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2M9 3a4 4 0 1 0 0 8 4 4 0 0 0 0-8zM23 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75",
  /** A rule that is in the product and cannot be switched off (the mailbox gate, the judge's three refusals). */
  lock: "M4 11h16v10H4zM8 11V7a4 4 0 0 1 8 0v4",
  chevronDown: "M6 9l6 6 6-6",
  chevronLeft: "M15 18l-6-6 6-6",
  chevronRight: "M9 18l6-6-6-6",
  copy: "M9 9h13v13H9zM5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1",
  wand: "M15 2v2M15 14v2M8 9h2M20 9h2M17.8 11.8 19 13M17.8 6.2 19 5M3 21l9-9M12.2 6.2 11 5",
  moon: "M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z",
  out: "M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4M16 17l5-5-5-5M21 12H9",
};
export type IconName = keyof typeof P | string;

export function Icon({ name, size = 16, className = "" }: { name: IconName; size?: number; className?: string }) {
  const d = P[name];
  if (!d) return null;
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" className={className} aria-hidden>
      <path d={d} />
    </svg>
  );
}
